import React, { useEffect, useRef, useState } from "react";

import { apiCall } from '@app/utils/apiCall';
import { useAuth } from '@app/contexts/AuthContext';
import SectionTitle from "@app/components/3_modules/sections/SectionTitle";
import { Calculator, ChevronUp, ChevronDown, ActivityIcon } from "lucide-react";
import AddedValue from "@app/components/2_widgets/dossiers/AddedValue";
import { useDossier } from "@app/contexts/DossierContext";
import Badge from "@app/components/1_elements/Badge";
import ElectricConsumption from "@app/components/2_widgets/dossiers/ElectricConsumption";

export default function ElectroEligibility() {    
    const [loaded, setLoaded] = useState();
    const [electroEligibility, setElectroEligibility] = useState(0);

    const dossier = useDossier();
    const auth = useAuth();

    useEffect(() => {        
        setLoaded(false);
    }, [dossier]);
    
    if (!loaded) {
        apiCall({
            method: "get",
            path: `/api/v1/structure_datas/electricity_intensity/${dossier.id}`,
            auth: auth,
            onSuccess: (response) => {
                setLoaded(true);
                setElectroEligibility(response.data.electricity_intensity);
            }
        });
    }    

    function displayEligibilityMessage() {
        if (electroEligibility > 0.5) {
            return (
                <div className="row custom-row success">
                    <div className="col">✓ L'entreprise est éligible au tarif réduit (électro-intensivité ≥ 0,5%)</div>                    
                </div>
            )  
        }              
        else {
            return (
                <div className="row custom-row error">
                    <div className="col">X L'entreprise n'est pas éligible au tarif réduit (électro-intensivité inférieur à 0,5%)</div>                    
                </div>                
            )
        }
    }
    
    return (
        <div className="page-section">
            <SectionTitle
                icon={<ActivityIcon />}
                title="Détermination de l'électro-intensivité"                                
                subtitle="Calcul automatique basé sur la consommation d'énergie et la valeur ajoutée"
            />
            <div className="row custom-row align-items-center">
                <div className="col-9">
                    Électro-intensivité
                </div>
                <div className="col-3">
                    <span className="xxl-text">{electroEligibility} %</span>
                </div>                
            </div>    
            {displayEligibilityMessage()}        
        </div>
    )
}